import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { User, UserManager } from 'oidc-client';
import * as NavigationStore from '../store/Navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faSignOut, faCircle, IconDefinition, faQuestionCircle } from '@fortawesome/pro-solid-svg-icons'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import { NavigationElementSummaryDto } from '../types/NavigationElementSummaryDto';
import AppSettings from '../types/AppSettings';
import { userHasAllRoles, userHasAnyRole } from '../utils/userRoleHelpers';
import { CommonAppState } from '../store';
import { getFoundationServiceSchemeAndHost } from '../utils/getFoundationServiceSchemeAndHost';
import MenuItem from '../types/MenuItem';
import SubMenuItem from '../types/SubMenuItem';
import Notifications from './Notifications';
import UserRequestModalForm from './UserRequests/UserRequestModal';
import { WorkItemType } from "./UserRequests/dto/WorkItemType";

type NavPrimaryProps = {
    appSettings: AppSettings;
    userManager: UserManager;
    user: User;
    navigationState: NavigationStore.NavigationState;
    actions: typeof NavigationStore.actionCreators;
}

interface NavPrimaryState {
    profileUri: string;
    showUserRequestModal: boolean;
    workItemType: WorkItemType;
}



class NavPrimary extends React.Component<NavPrimaryProps, NavPrimaryState> {

    constructor(props: NavPrimaryProps) {
        super(props);
        this.dismissUserRequestModal = this.dismissUserRequestModal.bind(this)
        this.state = {
            profileUri: "",
            showUserRequestModal: false,
            workItemType: WorkItemType.Unknown,
        };
    }

    public componentDidMount() {
        this.setState({
            profileUri: `${window.location.origin}/profile`
        });
    }

    logout = (event: any) => {
        event.preventDefault();
        this.props.userManager.signoutRedirect();
        this.props.userManager.removeUser();
    };



    // recursive method to build menu subitems within the service menu
    private subMenu(sub: NavigationElementSummaryDto[] | null) {
        if (sub === null) {
            return;
        }

        const leftCol = sub.splice(0, ~~(sub.length / 2));
        const rightCol = sub;

        return (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <ul>
                            {leftCol.map((item: NavigationElementSummaryDto, index: number) => {
                                return (
                                    <li key={index}>
                                        <Nav.Link className="text-dark" as="a" href={(item.path) ? item.path : '#'}>
                                            <FontAwesomeIcon className="me-2 list-bullet" icon={faCircle} /> {item.category}
                                        </Nav.Link>
                                        {this.subMenu(item.items)}
                                    </li>
                                );
                            })}
                        </ul>
                    </Col>
                    <Col md={6}>
                        <ul>
                            {rightCol.map((item: NavigationElementSummaryDto, index: number) => {
                                return (
                                    <li key={index}>
                                        <Nav.Link className="text-dark" as="a" href={(item.path) ? item.path : '#'}>
                                            <FontAwesomeIcon className="me-2 list-bullet" icon={faCircle} /> {item.category}
                                        </Nav.Link>
                                        {this.subMenu(item.items)}
                                    </li>
                                );
                            })}
                        </ul>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    // builds the item menu per category
    private itemMenu(items: NavigationElementSummaryDto[] | null) {
        if (items != null) {

            const columns: NavigationElementSummaryDto[][] = [[], [], []];

            for (let i = 0; i < items.length; i++) {
                columns[i % 3].push(items[i]);
            }

            return (
                <React.Fragment>
                    {columns.map((col: NavigationElementSummaryDto[], index: number) => {
                        return (
                            <Col key={index} md={3}>
                                {col.map((item: NavigationElementSummaryDto, index: number) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <Nav.Link className="text-dark" as="a" href={(item.path) ? item.path : '#'}>
                                                {item.category}
                                            </Nav.Link>
                                            {this.subMenu(item.items)}
                                        </React.Fragment>
                                    );
                                })}
                            </Col>
                        );
                    })}
                </React.Fragment>
            );
        }

        return <React.Fragment />
    }

    private showUserRequestModal(requestType: WorkItemType) {
        this.setState({
            workItemType: requestType,
            showUserRequestModal: true
        });

    }

    private dismissUserRequestModal() {
        this.setState({ showUserRequestModal: false });
    }

    serviceMenu = () => {
        const nav = this.props.navigationState.navigation.nav;

        return (
            <React.Fragment>
                {nav.map((menu: NavigationElementSummaryDto, index: number) => {

                    // the classes needed to make it look nice
                    let rowClass: string[] = ["mx-3", "pb-3"];

                    if (index < nav.length - 1) rowClass.push("menu-border");
                    if (index > 0) rowClass.push("mt-3");

                    return (
                        <Row key={index} className={rowClass.join(" ")}>
                            <Col md={3} className="menu-category">
                                {menu.category}
                            </Col>
                            {this.itemMenu(menu.items)}
                        </Row>
                    );
                })}
            </React.Fragment>
        );
    }

    render() {

        const navState = this.props.navigationState;

        const username = !this.props.user?.profile ? "" : `${this.props.user.profile.given_name} ${this.props.user.profile.family_name}`;

        return (
            <React.Fragment>
                <Navbar collapseOnSelect fixed="top" expand="lg" className="nav-primary flex-lg-nowrap p-0 bg-white">
                    <Container fluid className="px-0">
                        <Navbar.Brand href={getFoundationServiceSchemeAndHost()} className="d-flex w-50 me-auto">
                            <img
                                src={this.props.appSettings.navLogoAsset}
                                className="logo"
                                alt="Konica Minolta"
                            />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" className="me-2 ml-auto" />
                        <Navbar.Collapse id="responsive-navbar-nav" className="w-100 bg-white px-2">
                            <Nav className="w-100 justify-content-center">
                                {
                                    !navState.isLoadedNavigation
                                        ?
                                        <Spinner animation="border" variant="primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </Spinner>
                                        :
                                        <NavDropdown title={navState.navigation.service} id="service-nav-dropdown" className="menu-service">
                                            <this.serviceMenu></this.serviceMenu>
                                        </NavDropdown>
                                }
                            </Nav>
                            <NavDropdown.Divider />
                            <Nav className="menu-user ml-auto me-4 w-100 justify-content-end">
                                {/* help nav */}
                                <Nav.Item id="help-nav">
                                    <NavDropdown
                                        // alignRight
                                        id="help-nav-dropdown"
                                        title={
                                            <span><FontAwesomeIcon className="me-2 text-dark" icon={faQuestionCircle} />
                                                Help
                                            </span>
                                        }
                                    >
                                        <NavDropdown.Item onClick={() => this.showUserRequestModal(WorkItemType.Feature)}>
                                            Feature Request
                                        </NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => this.showUserRequestModal(WorkItemType.Bug)}>
                                            Problem Report
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </Nav.Item>
                                <Notifications />
                                <Nav.Item>
                                    <NavDropdown
                                        // alignRight
                                        id="user-nav-dropdown"
                                        title={
                                            <span><FontAwesomeIcon className="me-2 text-dark" icon={faUser} />
                                                {username}
                                            </span>
                                        }
                                    >
                                        <NavDropdown.Item href={this.state.profileUri}>
                                            <FontAwesomeIcon className="me-2" icon={faUser} />
                                            Profile
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as="a" href="#" onClick={(event: any) => this.logout(event)}>
                                            <FontAwesomeIcon className="me-2" icon={faSignOut} />
                                            Sign Out
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </Nav.Item>
                                {/* This menu is hidden in bigger devices with d-lg-none */}
                                <div className="d-xs-block d-lg-none">
                                    {this.props.appSettings.menuItems.map((menuItem: MenuItem, menuIndex: number) => {
                                        // Don't show this menu or its sub-menus if the menu item maps to an route that the user doesn't have access to
                                        if (menuItem.path !== undefined) {
                                            var appRoute = this.props.appSettings.routes.find(x => x.path === menuItem.path);
                                            if (appRoute === undefined) {
                                                return <React.Fragment />;
                                            }

                                            if (appRoute.requireAnyRoles !== undefined && !userHasAnyRole(this.props.user, appRoute.requireAnyRoles)) {
                                                return <React.Fragment />;
                                            }

                                            if (appRoute.requireAllRoles !== undefined && !userHasAllRoles(this.props.user, appRoute.requireAllRoles)) {
                                                return <React.Fragment />;
                                            }
                                        }

                                        // Render nav item for route together with sub-routes if any are defined
                                        return (
                                            <React.Fragment key={menuIndex}>
                                                {menuItem.path !== undefined && (
                                                    <Nav.Item key={menuItem.path}>
                                                        <Nav.Link className="text-dark" as={Link} to={menuItem.path}>
                                                            <FontAwesomeIcon className="me-2" icon={menuItem.menuIcon as IconDefinition} />
                                                            {menuItem.name}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                )}
                                                {menuItem.subMenuItems && menuItem.subMenuItems.map((subMenuItem: SubMenuItem, subMenuIndex: number) => {
                                                    // Resolve the route this menu item maps to
                                                    var appRoute = this.props.appSettings.routes.find(x => x.path === subMenuItem.path);
                                                    if (appRoute === undefined) {
                                                        return <React.Fragment />;
                                                    }

                                                    // Bail if the user doesn't have required roles
                                                    if (appRoute.requireAnyRoles !== undefined && !userHasAnyRole(this.props.user, appRoute.requireAnyRoles)) {
                                                        return <React.Fragment />;
                                                    }
                                                    if (appRoute.requireAllRoles !== undefined && !userHasAllRoles(this.props.user, appRoute.requireAllRoles)) {
                                                        return <React.Fragment />;
                                                    }

                                                    // Render sub-route using parent route's icon (sub-routes are not expected to have distinct icons)
                                                    return (
                                                        <Nav.Item key={subMenuIndex}>
                                                            <Nav.Link className="text-dark" as={Link} to={subMenuItem.path}>
                                                                <FontAwesomeIcon className="me-2" icon={subMenuItem.menuIcon as IconDefinition} />
                                                                {subMenuItem.name}
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                    )
                                                })}
                                            </React.Fragment>
                                        )
                                    })}
                                </div>
                            </Nav>
                        </Navbar.Collapse>
                        <UserRequestModalForm
                            isAdmin={userHasAnyRole(this.props.user, ["b8c2b209-79f5-4ccd-9a52-2af514a8ec65"])}
                            initialSubjectId={this.props.appSettings.clientId}
                            isOpen={this.state.showUserRequestModal}
                            handleClose={this.dismissUserRequestModal}
                            workItemType={this.state.workItemType} />
                    </Container>
                </Navbar>
            </React.Fragment>

        );
    }
}

function mapStateToProps(state: CommonAppState) {
    return {
        user: state.oidc.user,
        navigationState: state.navigation
    };
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, NavigationStore.actionCreators), dispatch)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavPrimary);